import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import partnersFields from '../../fields/partnersFields';
import { PUSH_PAYMENTS } from '../apiUrls';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].legalName
 * @param {string} responseData.items[].registrationNumber
 * @param {array} responseData.items[].connectionPoints
 * @param {number} responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [partnersFields.UUID.key]: item[partnersFields.UUID.key],
        [partnersFields.LEGAL_NAME.key]: item[partnersFields.LEGAL_NAME.key],
        [partnersFields.REGISTRATION_NUMBER.key]: item[partnersFields.REGISTRATION_NUMBER.key],
        [partnersFields.CONNECTION_POINTS.key]: item[partnersFields.CONNECTION_POINTS.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetPartners = ({ query }, enabled) => {
    return {
        queryKey: [PUSH_PAYMENTS.PARTNERS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(PUSH_PAYMENTS.PARTNERS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPartners;